import React, {FC, useEffect} from "react";
import facebookSvg from "images/Facebook.svg";
import twitterSvg from "images/Twitter.svg";
import googleSvg from "images/Google.svg";
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Link } from "react-router-dom";
import AuthService from "../../app/services/authService";

import toast from "react-hot-toast";
import Notify from "components/Notify";
import { Notification } from "app/helpers/sendnotification";

export interface PageSignUpProps {
  className?: string;
}

const loginSocials = [
  {
    name: "Continue with Facebook",
    href: "#",
    icon: facebookSvg,
  },
  {
    name: "Continue with Twitter",
    href: "#",
    icon: twitterSvg,
  },
  {
    name: "Continue with Google",
    href: "#",
    icon: googleSvg,
  },
];

const PageSignUp: FC<PageSignUpProps> = ({ className = "" }) => {

  useEffect(() => {

  }, [])
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const username = e.target.elements.username.value
    const firstname = e.target.elements.firstname.value
    const lastname = e.target.elements.lastname.value
    const email = e.target.elements.email.value
    const password = e.target.elements.password.value
    const data = {
      username: username,
      firstname: firstname,
      lastname: lastname,
      email: email,
      password: password,
    }

    AuthService.singup(data).then(singup => {
      let message = "Félicitations votre compte vient d'être créé, Vous recevrez un e-mail d'activation sous peu"
      let status = "success"
      if(singup.detail == 'IM Used'){
        message = "le nom d'utilisateur ou l'adresse e-mail est déjà utilisé"
        status = "warning"
      }
      Notification(status, message)
  
    })


  }
  return (
    <div className={`nc-PageSignUp  ${className}`} data-nc-id="PageSignUp">
      <Helmet>
        <title>Roupa | Inscription</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
        S'inscrire
        </h2>
        <div className="max-w-md mx-auto space-y-6 ">


          {/* FORM */}
          <form onSubmit={handleSubmit}  className="grid grid-cols-1 gap-6"  >
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200"> username  </span>
              <Input   name="username" type="text"  className="mt-1" />
            </label>
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200"> Prénom  </span>
              <Input   name="firstname" type="text" className="mt-1" />
            </label>
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200"> Nom  </span>
              <Input   name="lastname" type="text"  className="mt-1" />
            </label>
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200">
                Email 
              </span>
              <Input
                name="email"
                type="email"
                placeholder="example@example.com"
                className="mt-1"
              />
            </label>
            <label className="block">
              <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                Mot de passe
              </span>
              <Input type="password" name="password" className="mt-1" />
            </label>
            <ButtonPrimary type="submit">S'inscrire</ButtonPrimary>
          </form>
          {/* OR */}
          {/* <div className="relative text-center">
            <span className="relative z-10 inline-block px-4 font-medium text-sm bg-white dark:text-neutral-400 dark:bg-neutral-900">
              OU
            </span>
            <div className="absolute left-0 w-full top-1/2 transform -translate-y-1/2 border border-neutral-100 dark:border-neutral-800"></div>
          </div> */}

          {/* <div className="grid gap-3">
            {loginSocials.map((item, index) => (
                    <a
                      key={index}
                      href={item.href}
                      className=" flex w-full rounded-lg bg-primary-50 dark:bg-neutral-800 px-4 py-3 transform transition-transform sm:px-6 hover:translate-y-[-2px]"
                      >
                      <img
                        className="flex-shrink-0"
                        src={item.icon}
                        alt={item.name}
                      />
                      <h3 className="flex-grow text-center text-sm font-medium text-neutral-700 dark:text-neutral-300 sm:text-sm">
                        {item.name}
                      </h3>
                    </a>
                    ))}
          </div> */}
          {/* ==== */}
          <span className="block text-center text-neutral-700 dark:text-neutral-300">
          Vous avez déjà un compte?{` `}
            <Link className="text-green-600" to="/login">
            Se connecter
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default PageSignUp;
